exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("@tencent/docs-design-resources/icon/desktop/svg/arrowhead_down_12.svg"));

// Module
exports.push([module.id, ".index-wb-custom-select-r8M_8{box-sizing:border-box;height:24px;width:86px;border-radius:4px;border:1px solid #e0e0e0;display:flex;justify-content:space-between;flex-wrap:nowrap;align-items:center;padding:4px 5px}.index-wb-custom-select-r8M_8 .index-wb-custom-select-content-container-2V6bF{height:12px;flex-shrink:1;position:relative;width:100%}.index-wb-custom-select-r8M_8 .index-wb-custom-select-arrow-4Zihg{height:12px;width:12px;background:url(" + ___CSS_LOADER_URL___0___ + ");background-size:contain;flex-shrink:0;position:relative;top:-1px;left:4px}", ""]);

// Exports
exports.locals = {
	"wb-custom-select": "index-wb-custom-select-r8M_8",
	"wb-custom-select-content-container": "index-wb-custom-select-content-container-2V6bF",
	"wb-custom-select-arrow": "index-wb-custom-select-arrow-4Zihg"
};